import { CreateSecretInput30co61ns422r9 as CreateSecretInput } from './schema/type/CreateSecretInput.mjs';
import { CreateSecretMutation3m5frrt825225 as CreateSecretMutation } from './schema/CreateSecretMutation.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Secret2t4auo9luo6wh as Secret } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/Secret.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createSecretInput($this, command) {
  return new (CreateSecretInput())(command.b2m_1, command.c2m_1);
}
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.w6q(new (CreateSecretMutation())(createSecretInput(this, command)), $completion)).e44_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b6e_1;
  return tmp1_safe_receiver == null ? null : toDomain(tmp1_safe_receiver);
}
var SdkCreateSecretCommandDispatcherClass;
function SdkCreateSecretCommandDispatcher() {
  if (SdkCreateSecretCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkCreateSecretCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkCreateSecretCommandDispatcherClass = $;
  }
  return SdkCreateSecretCommandDispatcherClass;
}
function toDomain(_this__u8e3s4) {
  return to(new (Secret())(_this__u8e3s4.c6e_1, _this__u8e3s4.d6e_1, _this__u8e3s4.e6e_1, _this__u8e3s4.f6e_1), _this__u8e3s4.g6e_1);
}
//region block: exports
export {
  SdkCreateSecretCommandDispatcher as SdkCreateSecretCommandDispatcher1ii7hep4t7p2,
  perform as perform2es0c2ae6217b,
};
//endregion

//# sourceMappingURL=SdkCreateSecretCommandDispatcher.mjs.map
